import script from "./ContactTopSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactTopSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ContactTopSkeleton.vue?vue&type=style&index=0&id=a999acfe&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a999acfe"]])

export default __exports__